/**
 * ⚠️ HAND-WRITTEN FILE - DO NOT DELETE! ⚠️
 */

import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const CURRENT_FOCUS = [
  { label: 'Rust + Tokio', icon: '🦀' },
  { label: 'Spotify API', icon: '🎵' },
  { label: 'TanStack Start', icon: '⚡' },
  { label: 'OpenStreetMap', icon: '🗺️' },
  { label: 'Knowledge Graphs', icon: '🧠' },
  { label: 'VSCode Extensions', icon: '💻' },
];

export function HomeCurrentFocus() {
  return (
    <Box sx={{ bgcolor: 'background.paper', py: 6 }}>
      <Container maxWidth="lg">
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="center"
          flexWrap="wrap"
          sx={{ gap: 2 }}
        >
          <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 500 }}>
            Currently exploring:
          </Typography>
          {CURRENT_FOCUS.map((item) => (
            <Chip
              key={item.label}
              label={`${item.icon} ${item.label}`}
              size="medium"
              sx={{ fontSize: '0.95rem', fontWeight: 500, py: 2.5 }}
            />
          ))}
        </Stack>
      </Container>
    </Box>
  );
}
